// src/hooks/useDateFormat.js

import { useState, useEffect } from 'react';
import DateFormatService from '../Setup/controller/DateFormatController/DateFormatController'; // Adjust the path as needed

export const fetchActiveDateFormat = async () => {
  try {
    const response = await DateFormatService.GetActiveDateFormat();
    return response[0].DateFormat; // Assuming API returns the dateFormat field
  } catch (error) {
    console.error('Error fetching date format:', error);
    throw error; // In case you want to handle the error elsewhere
  }
};


const useDateFormat = () => {
  const [activeDateFormat, setActiveDateFormat] = useState('');

  useEffect(() => {
    const getDateFormat = async () => {
      try {
        const dateFormat = await fetchActiveDateFormat(); // Fetch the date format      
        setActiveDateFormat(dateFormat);
      } catch (error) {
        console.error('Failed to fetch date format:', error);
      }
    };

    getDateFormat();
  }, []);

  return activeDateFormat;
};

export default useDateFormat;
